import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M7 .5a.5.5 0 0 0-.5-.5 5 5 0 0 0-5 5v4.5c0 1.395 0 2.092.138 2.667a5 5 0 0 0 3.695 3.695C5.908 16 6.605 16 8 16s2.092 0 2.667-.138a5 5 0 0 0 3.695-3.695c.138-.575.138-1.272.138-2.667v-.773c0-.211 0-.317-.031-.402a.5.5 0 0 0-.294-.293C14.09 8 13.985 8 13.773 8H12c-.419 0-.628 0-.758.093-.13.092-.223.358-.406.889A3.001 3.001 0 0 1 5 8V6c0-1.055.544-1.982 1.367-2.517.341-.222.512-.333.572-.444C7 2.927 7 2.773 7 2.464z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M7.03 5.753Q7 5.872 7 6v2a1 1 0 0 0 2 0V6a1 1 0 0 0-1.97-.247"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#CF0",
  d: "M9.5 0a.5.5 0 0 0-.5.5v1.964c0 .309 0 .463.06.575.061.111.232.222.573.444.554.36.983.9 1.203 1.535.184.531.275.797.406.89.13.092.34.092.758.092h1.954l.082-.001a.5.5 0 0 0 .463-.463l.001-.081V5a5 5 0 0 0-5-5"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }